import type { CustomizationDataQueryVariables } from '../../graphql/CustomizationData.generated';
import type { Context } from './context';
import type { Event } from './events';

// ─────────────────────────────────────────────────────────────────────────────

export type Input = {
  productSlug: string;
  restaurantSlug: string;
  lineItemId: string | undefined;
  ingredientAssetVersion: CustomizationDataQueryVariables['ingredientAssetVersion'];
  isDelivery: boolean;
};

// ─────────────────────────────────────────────────────────────────────────────

export type CustomizationMachineInput<InputType> = (actionArgs: {
  context: Context;
  event: Event;
}) => InputType;
